module.exports = __webpack_public_path__ + "img/tuna-pasta-bake.af4c199b.jpg";